module.exports = __webpack_public_path__ + "static/media/skhu_erdf_hu.066eaace.png";